import { Component, Input, OnInit } from '@angular/core';
import { CyclistService } from "../../../../services/cyclist.service";
import { ServiceRequestService } from "../../../../services/servicerequest.service";
import { HelpersService } from "../../../../services/helpers.service";
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-fitting-info',
  templateUrl: './fitting-info.component.html',
  styleUrls: ['./fitting-info.component.scss']
})
export class FittingInfoComponent implements OnInit {

  @Input() partnerID;
  @Input() jobcard; 
  @Input() bike; 
  public fittingInfo : any = {};
  public countryData : any = {};
  public editGoalsOfFitSession = false;
  public editAreasOfDiscomfort = false;
  public editInjuryHistory = false;
  public editRidingGoals = false;
  public editYearsOfRiding = false;

  constructor(
    private cyclistService : CyclistService,
    private serviceRequest : ServiceRequestService,
    private helpersService : HelpersService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.getFittingInfo();
    if(this.jobcard.GoalsOfFitSession === null || this.jobcard.GoalsOfFitSession === ""){
      this.editGoalsOfFitSession = true;
    }
  }

  getFittingInfo(){
    this.cyclistService.getFittingInfo(this.jobcard.CyclistID).subscribe(fittingInfo=>{
      this.fittingInfo = fittingInfo;
      this.fittingInfo.previousFittings = this.fittingInfo.previousFittings.filter(x=>{return x.id !== this.jobcard.ID});
      this.editAreasOfDiscomfort = fittingInfo.areasOfDiscomfort === null || fittingInfo.areasOfDiscomfort === "";
      this.editInjuryHistory = fittingInfo.injuryHistory === null || fittingInfo.injuryHistory === "";
      this.editRidingGoals = fittingInfo.ridingGoals === null || fittingInfo.ridingGoals === "";
      this.editYearsOfRiding = fittingInfo.yearsRiding === null || fittingInfo.yearsRiding === "";
    });
  }

  updateFittingsInfo(update, inline = false){
    this.cyclistService.updateFittingInfo(this.fittingInfo).subscribe(fittingInfo=>{
      this.fittingInfo = fittingInfo;
      this.fittingInfo.previousFittings = this.fittingInfo.previousFittings.filter(x=>{return x.id !== this.jobcard.ID});
      this.editAreasOfDiscomfort = fittingInfo.areasOfDiscomfort === null || fittingInfo.areasOfDiscomfort === "";
      this.editInjuryHistory = fittingInfo.injuryHistory === null || fittingInfo.injuryHistory === "";
      this.editRidingGoals = fittingInfo.ridingGoals === null || fittingInfo.ridingGoals === "";
      this.editYearsOfRiding = fittingInfo.yearsRiding === null || fittingInfo.yearsRiding === "";

      if(inline){
        update.deactivate();
      }else{
        update = false;
      }
    });
  }

  updateGoalsForFitSession(){
    this.serviceRequest.saveServiceRequest(this.jobcard).subscribe(result =>{
      this.jobcard = result;
      if(this.jobcard.GoalsOfFitSession === null || this.jobcard.GoalsOfFitSession === ""){
        this.editGoalsOfFitSession = true;
      }else{
        this.editGoalsOfFitSession = false;
      }
    });
  }


  openJobcard(fitting){
    if(fitting.partnerID === this.partnerID && fitting.id !== this.jobcard.ID){
      this.serviceRequest.getServiceRequestData(fitting.id).subscribe(jobcard => {
        const modalRef = this.modalService.open(UpdateJobcardComponent, { size: 'lg', backdrop: 'static', windowClass: 'jobcard-modal' });
        modalRef.componentInstance.jobcard = jobcard;
        modalRef.componentInstance.partnerID = this.partnerID;
        modalRef.result.then((result) => {
        
        }, (onrejected => {
        }));
      });
    }
  }

}
